module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (this.$store.state.accomodationView && _vm.$store.state.accomodationView === 'images') ? _c('div', {
    staticClass: "notification center"
  }, [_c('p', [_vm._v("Du visar nu våra boenden i ett specialläge där du kan ladda ner bilder.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToNormal()
      }
    }
  }, [_vm._v("Gå till vanliga visningsläget")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number) ? _c('div', [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Tilläggsbokning")])]) : _c('div', [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Boka din nästa semester")])])]), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.accomodation.fully_open) ? _c('Note', {
    attrs: {
      "title": "Bokningen för vintersäsongen 25/26 är öppen",
      "color": "blue"
    }
  }, [_c('p', [_vm._v("Boenden släpps löpande fram till 1 juli.")])]) : _vm._e(), _vm._v(" "), (_vm.cancellationInsuranceEnabled && _vm.SITE_CONFIG.accomodations.cancellation_insurance.text_list) ? _c('div', {
    staticClass: "notification notification--blue center cancellation-insurance-notice",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.cancellation_insurance.text_list)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModal()) ? _c('Modal', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'waiting-for-filter': _vm.isAwaitingFilter || _vm.loading
    }
  }, [_c('AccomodationsFilter', {
    attrs: {
      "filterObject": _vm.filterObject
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('AccomodationsFilterInfo', {
    attrs: {
      "unitCount": _vm.unitCount,
      "poolCount": _vm.poolCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.isAwaitingFilter,
      "text": "Filter tillämpas"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('AccomodationsList', {
    attrs: {
      "pools": _vm.filteredPools,
      "locations": _vm.locations
    }
  }) : _vm._e(), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04e80786"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Accomodation/AccomodationsPage.vue
// module id = 871
// module chunks = 0